"use client"

import React, { createContext, useContext } from "react"
import { Promotion } from "@lib/util/promotions"

/**
 * Promociones automáticas activas de Medusa, disponibles en todo el layout
 * principal. Los componentes de precio las consumen con `usePromotions()`
 * para calcular el descuento de productos servidos por la API de Medusa
 * (los hits de MeiliSearch traen el precio de oferta precalculado y no
 * necesitan las promociones).
 */
const PromotionsContext = createContext<Promotion[]>([])

export function PromotionsProvider({
  promotions,
  children,
}: {
  promotions: Promotion[]
  children: React.ReactNode
}) {
  return (
    <PromotionsContext.Provider value={promotions}>
      {children}
    </PromotionsContext.Provider>
  )
}

export function usePromotions(): Promotion[] {
  return useContext(PromotionsContext)
}
